const hotels = {
  accommodation: "إقامة", // translated 
  hotel: "الفندق", // translated 
  hotels: "الفنادق", // translated 
  back: "خلف", // translated 
  rooms: "غرف", // translated 
  viewPictures: "عرض الصور", // translated 
  showMore: "أظهر المزيد", // translated 
  bookingInformation: "معلومات الحجز", // translated 
  cancellationPolicy: "سياسة الإلغاء", // translated 
  from: "من", // translated 
  to: "ل", // translated 
  cancellationIs: "الإلغاء هو", // translated 
  free: "حر", // translated 
  chargeableWithFeeOf: "تحميلها مع رسوم", // translated 
  prebook: "الحجز المسبق", // translated 
  guests: "ضيوف", // translated 
  payment: "قسط", // translated 
  byClicking: "بالضغط", // translated 
  next: "التالي", // translated 
  youAreAgreeingToOur: "أنت توافق على لدينا", // translated 
  termsAndConditions: "الأحكام والشروط", // translated 
  previous: "سابق", // translated 
  cancel: "إلغاء", // translated 
  mealPlan: "خطة الوجبة", // translated 
  roomType: "نوع الغرفة", // translated 
  description: "وصف", // translated 
  readLess: "أقرأ أقل", // translated 
  readMore: "اقرأ أكثر", // translated 
  facilities: "مرافق", // translated 
  viewLess: "عرض أقل", // translated 
  viewMore: "عرض المزيد", // translated 
  less: "أقل", // translated 
  more: "أكثر", // translated 
  notAvailable_short: "لا يوجد", // translated 
  backToHotelList: "العودة إلى قائمة الفنادق", // translated 
  viewOnMap: "عرض على الخريطة", // translated 
  sleeps: "ينام", // translated 
  adults: "الكبار", // translated 
  yearsOld: "سنة", // translated 
  type: "يكتب", // translated 
  bedding: "الفراش", // translated 
  selectRoom: "اختر الغرفة", // translated 
  selectRooms: "اختر الغرف", // translated 
  city: "مدينة", // translated 
  checkIn: "تحقق في", // translated 
  checkOut: "الدفع", // translated 
  date: "تاريخ", // translated 
  dates: "التاريخ", // translated 
  persons: "الأشخاص", // translated 
  stillOnTrialQuestionToUpgrade:
    "أُووبس! يبدو أنك لا تزال عضوًا تجريبيًا. يجب أن تكون عضوًا مؤكدًا لإجراء الحجوزات. هل تريد الترقية الآن؟", // translated 
  stillOnTrialQuestionToUpgradeNonElligib:
    "أُووبس! يبدو أنك لم تشترك بعد. يجب أن تكون عضوًا مؤكدًا لإجراء الحجوزات. هل تريد الترقية الآن؟", // translated 
  completeProfile: "يرجى إكمال ملف تعريف المستخدم الخاص بك أولاً", // translated 
  upgrade: "يرقي", // translated 
  close: "يغلق", // translated 
  viewDetails: "عرض التفاصيل", // translated 
  name: "اسم", // translated 
  rating: "تقييم", // translated 
  budget: "ميزانية", // translated 
  orderBy: "ترتيب حسب", // translated 
  priceLowestFirst: "السعر (الأدنى أولاً)", // translated 
  priceHighestFirst: "السعر (الأعلى أولاً)", // translated 
  ratingLowestFirst: "التقييم (الأدنى أولاً)", // translated 
  ratingHighestFirst: "التقييم (الأعلى أولاً)", // translated 
  starRatingAndPrice: "تصنيف النجوم والسعر", // translated 
  biggestSavingsFirst: "أكبر الادخار أولا", // translated 
  select: "يختار", // translated 
  reset: "إعادة ضبط", // translated 
  apply: "تأكيد", // translated 
  filterBy: "مصنف بواسطة", // translated 
  myProfile: "ملفي", // translated 
  login: "تسجيل الدخول", // translated 
  roomOnly: "غرفة فقط", // translated 
  bedAndBreakfast: "سرير و فطور", // translated 
  halfBoard: "نصف إقامة", // translated 
  fullBoard: "ممتلئ", // translated 
  allInclusive: "الجميع مشمول", // translated 
  filter: "منقي", // translated 
  mapView: "عرض الخريطة", // translated 
  results: "نتائج", // translated 
  listView: "عرض القائمة", // translated 
  newSearch: "بحث جديد", // translated 
  editSearch: "تحرير البحث", // translated 
  all: "الجميع", // translated 
  multiple: "عديد", // translated 
  editProfile: "تعديل الملف الشخصي", // translated 
  backToHotelsList: "العودة إلى قائمة الفنادق", // translated 
  roomName: "اسم الغرفة", // translated 
  mealType: "نوع الوجبة", // translated 
  freeCancellation: "إلغاء مجاني", // translated 
  yes: "نعم", // translated 
  no: "لا", // translated 
  filters: "المرشحات", // translated 
  cancellationNonRefundable: "الإلغاء غير قابل للاسترداد", // translated 
  hotelRating: "تصنيف الفندق", // translated 
  any: "أي", // translated 
  off: "عن", // translated 
  performNewSearch: "إجراء بحث جديد", // translated 
};



export default hotels;
